var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 18,
    viewBox: "0 0 10 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.24983 9.88752C3.13266 9.77131 3.03967 9.63306 2.97621 9.48074C2.91275 9.32841 2.88008 9.16503 2.88008 9.00002C2.88008 8.835 2.91275 8.67162 2.97621 8.51929C3.03967 8.36697 3.13266 8.22872 3.24983 8.11252L8.98732 2.38751C9.10449 2.27131 9.19748 2.13306 9.26094 1.98074C9.3244 1.82841 9.35707 1.66503 9.35707 1.50001C9.35707 1.335 9.3244 1.17162 9.26094 1.01929C9.19748 0.866969 9.10449 0.728718 8.98732 0.612514C8.75312 0.3797 8.43631 0.249023 8.10608 0.249023C7.77584 0.249023 7.45903 0.3797 7.22482 0.612514L1.48732 6.35002C0.785072 7.05314 0.390625 8.00626 0.390625 9.00002C0.390625 9.99377 0.785072 10.9469 1.48732 11.65L7.22482 17.3875C7.45765 17.6184 7.7719 17.7486 8.09982 17.75C8.26433 17.751 8.42741 17.7194 8.57971 17.6572C8.73201 17.595 8.87053 17.5034 8.98732 17.3875C9.10449 17.2713 9.19748 17.1331 9.26094 16.9807C9.3244 16.8284 9.35707 16.665 9.35707 16.5C9.35707 16.335 9.3244 16.1716 9.26094 16.0193C9.19748 15.867 9.10449 15.7287 8.98732 15.6125L3.24983 9.88752Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.db704164710b0f5e79cdde9f57034765.svg";
export { ForwardRef as ReactComponent };